import axiosInstance from "shared/axios";
import { MERCHANT_OFFER_MAP_APIS,MERCHANT_OFFER } from "shared/constants";
import {queryparamBuilder} from 'shared/utils';

export const fetchOfferMapList = (selectedFilter,search,params) => {
    let uri = MERCHANT_OFFER_MAP_APIS.listing;
    if (selectedFilter) {
      uri += `?search_cond=${selectedFilter}&search_terms=${search}&`;
    } else if (Object.keys(params).length) {
      uri += "?";
    }
    uri += queryparamBuilder(params);
    return axiosInstance.post(`${uri}`);
  };

export const fetchOfferMapViewData  = (id) => {
        return axiosInstance.get(`/api/v1/transactions/promo-offer/${id}/offer-map-view`);
    };
    
export const fetchSetOfferDetails  = (id) => {
        return axiosInstance.Patch(`api/v1/transactions/promo-offer/${id}/set-default-offer`);
    };
       
export const offerDropDwonList = (param) => {
    let fullParam = param ? `${MERCHANT_OFFER_MAP_APIS.listing}${param}` : `${MERCHANT_OFFER_MAP_APIS.listing}`;
    return axiosInstance.post(fullParam);
    };

export const fetchOfferDropdownData = (data) => {
    let url = `${MERCHANT_OFFER_MAP_APIS.dropdownData}`;
    return axiosInstance.post(url,data);
    };

export const onSubmitAddOfferMapData = (data) => {
    let url = `${MERCHANT_OFFER_MAP_APIS.add}`;
    return axiosInstance.post(url,data);
    };
export const onSubmiEdittOfferMapData = (id,data) =>{
    let url = `${MERCHANT_OFFER_MAP_APIS.update}/${id}/offer-map-update`;
    return axiosInstance.patch(url,data);
}
export const fetchOfferList = (param) => {
  let url = `${MERCHANT_OFFER.listing}`;
    return axiosInstance.post(url,param);
};

export const fetchView = (id) => {
    let url = `${MERCHANT_OFFER.view}/${id}/view`;
      return axiosInstance.get(url);
};

export const createApi = (param) => {
    let url = `${MERCHANT_OFFER.create}`;
      return axiosInstance.post(url,param);
};
